import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import { autobind } from 'core-decorators';

import { resetPassword } from 'services/api';

import { Input } from 'AppComponents/Forms/Formsy';
import Modal, { ModalBody, ModalFooter } from 'AppComponents/Modal';
import Alert from 'AppComponents/Alert';


class PasswordReset extends Component {

  static propTypes = {
    display: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    handleSuccess: PropTypes.func,
  }

  static defaultProps = {
    display: false,
    handleSuccess: () => {},
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      enableSubmit: false,
      isSubmitting: false,
      serverError: null,
      successMsg: null,
    };
  }

  @autobind
  handleSubmit(data, resetForm, invalidateForm) {
    this.setState({ isSubmitting: true }, () => {
      resetPassword(data).then(({ response, error }) => {
        if (error) {
          this.setState({ isSubmitting: false });
          if (typeof error === 'object' && Object.keys(error).length !== 0) {
            this.setState({ serverError: error.detail });
            delete error.detail;
            const errors = {};
            Object.keys(error).forEach((field) => {
              errors[field] = error[field][0];
            });
            invalidateForm(errors);
          } else {
            this.setState({ serverError: 'An unknown error occurred. Please try again.' });
          }
        } else {
          this.setState({
            serverError: null,
            successMsg: `We've sent an email to ${response.email} with a link to reset your password!`, // eslint-disable-line max-len
          });
          this.props.handleSuccess(response);
        }
      });
    });
  }

  render() {
    const { display, handleClose } = this.props;

    const { enableSubmit, isSubmitting, serverError, successMsg } = this.state;

    return (
      <Modal
        title='Forgot Your Password?'
        display={display}
        handleClose={handleClose}
      >

        <Formsy.Form
          className='form forgot-password'
          onValid={() => this.setState({ enableSubmit: true })}
          onInvalid={() => this.setState({ enableSubmit: false })}
          onValidSubmit={this.handleSubmit}
          noValidate
        >

          <ModalBody>

            <Alert type='danger' display={serverError && true}>
              <strong>Error: </strong>{serverError}
            </Alert>

            <Alert type='success' display={successMsg && true}>
              {successMsg}
            </Alert>

            <p className='help-block'>
              Enter your username or email address in the field below, and we&#8217;ll send a&nbsp;
              link to reset your password to your email address.
            </p>

            <Input
              name='lookup'
              label='Username or Email Address'
              required
            />

          </ModalBody>

          <ModalFooter
            submitButtonLabel='Send Password Reset Email'
            submitButtonEnabled={enableSubmit}
            isSubmitting={isSubmitting}
          />

        </Formsy.Form>

      </Modal>
    );
  }
}

export default PasswordReset;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Login/PasswordReset.jsx